import axios from "axios";
import { newApiBaseUrl, aspNetUrl } from "../../axiosInstance";

export const GetPriceList = async (gtin, isAdmin) => {
  try {
    const params = {
      gtin,
      includeHamazon: false,
      role: isAdmin ? "admin" : "client",
    };
    const response = await axios.get(`${newApiBaseUrl}/productprices`, {
      params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetAllBranches = async () => {
  try {
    const response = await axios.get(`${newApiBaseUrl}/admin/branches`, {
      headers: {
        Authorization: `bearer ${localStorage.jwtToken}`,
        "Content-Type": "application/json",
        "X-Tenant": "hamazon",
      },
    });
    return response.data;
  } catch (error) {
    console.error("שגיאה בשליפת החברות", error);
    throw error;
  }
};

export const UpdatePriceListOrder = async (orderedIds) => {
  try {
    const requestBody = {
      retailerBranches: orderedIds,
    };
    console.log("orderedIds", JSON.stringify(orderedIds));
    const response = await axios.post(
      `${newApiBaseUrl}/admin/branches/updateOrder`,
      requestBody,
      {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
          "Content-Type": "application/json",
          "X-Tenant": "hamazon",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("שגיאה בעדכון סדר", error);
    throw error;
  }
};

export const UpdateSortType = async (sortType) => {
  try {
    const response = await axios.post(
      `${aspNetUrl}priceList/setSortType`,
      { sortType },
      {
        headers: {
          Authorization: `bearer ${localStorage.token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("שגיאה בעדכון סוג מיון", error);
    throw error;
  }
};

export const UpdateCompanyDisplayStatus = async (
  company,
  isVisibleToCustomer,
  jwt,
  tenant,
) => {
  try {
    const branchId = `${company.retailer}-${company.branch}`;
    const response = await fetch(
      `${newApiBaseUrl}/admin/branches/${branchId}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${jwt}`,
          "X-Tenant": tenant,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          retailerName: company.retailerName,
          branchName: company.branchName,
          autoUpdate: company.autoUpdate,
          priceSiteUrl: company.priceSiteUrl,
          isVisibleToCustomer: isVisibleToCustomer ?? false,
        }),
      },
    );

    if (!response.ok) {
      throw new Error("Failed to save branch");
    }

    return await response.json();
  } catch (error) {
    console.error("שגיאה בעדכון תצוגת החברה", error);
    throw error;
  }
};

export const GetSales = async (gtin) => {
  try {
    const params = {
      gtin,
      retailer: "Hamazon",
      branch: 4,
    };

    const response = await axios.get(`${newApiBaseUrl}/productprices`, {
      params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching price list:", error);
    throw error;
  }
};

export const GetPromotions = async (data) => {
  try {
    const response = await axios.get(`${newApiBaseUrl}/promotions`, {
      params: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching promotions:", error);
    throw error;
  }
};

export const createPromotion = async (promotionData) => {
  try {
    const response = await axios.post(
      `${newApiBaseUrl}/promotions`,
      promotionData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error creating promotion:", error);
    throw error;
  }
};

export const updatePromotion = async (promoId, promotionData) => {
  try {
    const response = await axios.put(
      `${newApiBaseUrl}/promotions/${promoId}`,
      promotionData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error updating promotion:", error);
    throw error;
  }
};
